import React, {useState} from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import ImageUpload from "../../../layout/ImageUpload/index";
import {logoNorm, logoIDE, UI} from "../../../data/constants";
import {checkIfIDE} from "../../../data/products/index";
import Icon from "../../../layout/Icon";
import BgTransformer from "../../../layout/BgTransformer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import {HIDING_NAME_SET} from "data/products/index";

const BlogSocialShareInternal = ({id, zoom}) => {
  const {product, layoutOption, iconOption, locked, visible} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, subtitles, productNames} = useEdits();
  const logoURL = useLogoUrl(id);
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;
  const productName = productNames[id] || productNames.main || product.shortLabel || product.label;
  const iconUrl = `${UI}/Icons/${iconOption}.svg`;
  const templateClass = cn("template", `layout-${layoutOption}`);
  const contentClass = cn("content", `layout-${layoutOption}`);
  const uploadClass = cn("upload-wrap", `layout-${layoutOption}`);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value)});
  const isLocked = locked.some((elem) => elem === id);
  const isVisible = visible.some((elem) => elem === id);

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />

          <div className="content">
            <header className="template-header">
              <div className={logoClass}>
                <img src={logoURL} alt="background" />
              </div>
              {HIDING_NAME_SET.has(product.value) ? (
                ""
              ) : (
                <div className="product-name">
                  <ContentEditable id={id} text={productName} />
                </div>
              )}
            </header>

            <div className="title-wrap">
              <h1 className="title">
                <Textarea id={id} text={title} />
              </h1>
              {[3, 4].includes(layoutOption) && (
                <h2 className="subtitle">
                  <Textarea id={id} lines="1" text={subtitle} />
                </h2>
              )}
            </div>
          </div>
          {+layoutOption === 7 && (
            <div className="icon-wrap">
              <Icon bgUrl={iconUrl} />
            </div>
          )}
          {[5, 6].includes(+layoutOption) && (
            <div className="upload-wrap">
              <ImageUpload id={id} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BlogSocialShareInternal;
